{
  "version": 1,
  "asset_id": "49ae0ce2-151c-4c6d-89b8-5e25cbbae55b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/49ae0ce2-151c-4c6d-89b8-5e25cbbae55b/crystal-river-blue-shingle-roof-destination-roofing-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/49ae0ce2-151c-4c6d-89b8-5e25cbbae55b/crystal-river-blue-shingle-roof-destination-roofing-768w.avif",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-768w.avif",
  "size": 27737,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
